module.exports = __webpack_public_path__ + "static/img/pic_coupon.13d8279.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/events/special_event2019/pic_coupon.jpg
// module id = 724
// module chunks = 1